import React from 'react';
import ModalDialog from './ModalDialog';
import {CircularProgress} from "@material-ui/core";

function LoadingModal({title}: {title?: string}) {
    return (
        <ModalDialog open={Boolean(title)} onClose={() => {}}
                     title={title}
                     content={<div style={{textAlign: 'center', margin: '4rem'}}>
                         <CircularProgress/>
                     </div>}/>
    );
}

export default LoadingModal;